import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';

import KeypadIcon from '../../assets/images/keypadIcon.png';
import OpenRobotIcon from '../../assets/images/openRobotIcon.png';
import CloseRobotIcon from '../../assets/images/closeRobotIcon.png';

const useStyles = makeStyles(theme => ({
  marginBottom: { marginBottom: '30px' },
  stepContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
  },
  stepIcon: { marginRight: '10px', width: '48px', height: '48px' },
  stepsWrapper: {
    padding: '20px',
    borderRadius: '8px',
    maxWidth: '400px',
    width: '100%',
    boxSizing: 'border-box',
    margin: '0 auto',
    textAlign: 'left',
  },
  card: {
    backgroundColor: theme.palette.type === 'dark' ? '#4D4B3A' : '#FFFBE6',
    border:
      theme.palette.type === 'dark'
        ? '0.5px solid #B3A125'
        : '0.5px solid #FFD500',
    padding: '10px',
    borderRadius: '5px',
    marginTop: '20px',
  },
}));

const RobotDeliverySteps = ({ robotName, noBreaks }) => {
  const styles = useStyles();

  return (
    <div>
      <Typography className={styles.deliveryInfo}>
        To retrieve your parcel from robot <br />
        {robotName}, follow these 3 steps:
      </Typography>
      <div className={clsx(styles.stepsWrapper, styles.marginBottom)}>
        <div className={styles.stepContainer}>
          <img src={KeypadIcon} alt="Keypad Icon" className={styles.stepIcon} />{' '}
          <Typography className={styles.deliveryInfo}>
            Enter the 4-digit code we sent you on the {noBreaks ? '' : <br />}{' '}
            robot's lid
          </Typography>
        </div>

        <div className={styles.stepContainer}>
          <img
            src={OpenRobotIcon}
            alt="Open Robot Icon"
            className={styles.stepIcon}
          />
          <Typography className={styles.deliveryInfo}>
            Lift the main lid, which is now unlocked. The lid of the interior
            compartment containing your parcel will open automatically
          </Typography>
        </div>

        <div className={styles.stepContainer}>
          <img
            src={CloseRobotIcon}
            alt="Close Robot Icon"
            className={styles.stepIcon}
          />
          <Typography className={styles.deliveryInfo}>
            Take your parcel out of the compartment and close both lids
          </Typography>
        </div>
      </div>
      <div className={styles.card}>
        <Typography className={styles.deliveryInfo}>
          Don’t forget to close the lids or the robot won’t be{' '}
          {noBreaks ? '' : <br />} able to leave and deliver the next parcel!
        </Typography>
      </div>
    </div>
  );
};

RobotDeliverySteps.propTypes = {
  robotName: PropTypes.string.isRequired,
  noBreaks: PropTypes.bool,
};

export default RobotDeliverySteps;
